/**
 * SectionHeaderBlock - Section divider with title
 */

import React from 'react'
import { SectionHeaderBlock as SectionHeaderBlockType } from '../../../../lib/cockpit/schemas'

interface SectionHeaderBlockProps {
  data: SectionHeaderBlockType['data']
  blockId: string
}

function SectionHeaderBlock({ data, blockId }: SectionHeaderBlockProps) {
  const level = data.level ?? 2
  
  const sizeClasses = {
    1: 'text-2xl font-bold',
    2: 'text-xl font-semibold',
    3: 'text-lg font-medium',
  }[level as 1 | 2 | 3] ?? 'text-lg font-medium'

  return (
    <div className="py-2">
      <h2 className={`${sizeClasses} text-gray-900 dark:text-white`}>
        {data.title}
      </h2>
      {data.subtitle && (
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          {data.subtitle}
        </p>
      )}
    </div>
  )
}

export default SectionHeaderBlock



